export type CzechCalendarDayInfo = {
  label: string
  kind: 'holiday' | 'special'
}

function dateKey(date: Date) {
  return `${date.getMonth() + 1}-${date.getDate()}`
}

function easterSunday(year: number) {
  const a = year % 19
  const b = Math.floor(year / 100)
  const c = year % 100
  const d = Math.floor(b / 4)
  const e = b % 4
  const f = Math.floor((b + 8) / 25)
  const g = Math.floor((b - f + 1) / 3)
  const h = (19 * a + b - d - g + 15) % 30
  const i = Math.floor(c / 4)
  const k = c % 4
  const l = (32 + 2 * e + 2 * i - h - k) % 7
  const m = Math.floor((a + 11 * h + 22 * l) / 451)
  const month = Math.floor((h + l - 7 * m + 114) / 31)
  const day = ((h + l - 7 * m + 114) % 31) + 1
  return new Date(year, month - 1, day)
}

function moveDate(date: Date, days: number) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days)
}

function nthWeekday(
  year: number,
  month: number,
  weekday: number,
  occurrence: number
) {
  const first = new Date(year, month, 1)
  const offset = (weekday - first.getDay() + 7) % 7
  return new Date(year, month, 1 + offset + (occurrence - 1) * 7)
}

const PUBLIC_HOLIDAYS: Record<string, string> = {
  '1-1': 'Den obnovy samostatného českého státu a Nový rok',
  '5-1': 'Svátek práce',
  '5-8': 'Den vítězství',
  '7-5': 'Den slovanských věrozvěstů Cyrila a Metoděje',
  '7-6': 'Den upálení mistra Jana Husa',
  '9-28': 'Den české státnosti',
  '10-28': 'Den vzniku samostatného československého státu',
  '11-17': 'Den boje za svobodu a demokracii a Mezinárodní den studentstva',
  '12-24': 'Štědrý den',
  '12-25': '1. svátek vánoční',
  '12-26': '2. svátek vánoční',
}

const SPECIAL_DAYS: Record<string, string> = {
  '2-14': 'Den svatého Valentýna',
  '3-8': 'Mezinárodní den žen',
  '4-30': 'Čarodějnice',
  '6-1': 'Mezinárodní den dětí',
  '11-2': 'Památka zesnulých',
  '12-5': 'Mikuláš',
  '12-31': 'Silvestr',
}

export function getCzechCalendarDayInfo(
  date: Date
): CzechCalendarDayInfo | undefined {
  const key = dateKey(date)
  const publicHoliday = PUBLIC_HOLIDAYS[key]
  if (publicHoliday) return { label: publicHoliday, kind: 'holiday' }

  const easter = easterSunday(date.getFullYear())
  if (dateKey(date) === dateKey(moveDate(easter, -2))) {
    return { label: 'Velký pátek', kind: 'holiday' }
  }
  if (dateKey(date) === dateKey(moveDate(easter, 1))) {
    return { label: 'Velikonoční pondělí', kind: 'holiday' }
  }
  if (dateKey(date) === dateKey(easter)) {
    return { label: 'Velikonoční neděle', kind: 'special' }
  }

  const mothersDay = nthWeekday(date.getFullYear(), 4, 0, 2)
  if (dateKey(date) === dateKey(mothersDay)) {
    return { label: 'Den matek', kind: 'special' }
  }

  const fathersDay = nthWeekday(date.getFullYear(), 5, 0, 3)
  if (dateKey(date) === dateKey(fathersDay)) {
    return { label: 'Den otců', kind: 'special' }
  }

  const specialDay = SPECIAL_DAYS[key]
  return specialDay ? { label: specialDay, kind: 'special' } : undefined
}
